export const catalog = [
  {
    code: "CP95",
    name: "Port Authority® Beanie",
    fullname: "Port Authority® 100% Cotton Beanie",
    colors: ["Navy"],
    type: "mens",
    default_color: "Navy",
    sizes: {
      OSFA: 8.49,      
    },
  },
  {
    code: "CGM211",
    name: "Callaway Performance Polo",
    fullname: "Callaway Core Performance Polo",
    colors: ["Black","Peacoat"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 42.99,
      Medium: 42.99,
      Large: 42.99,
      XLarge: 42.99,
      "2XLarge": 43.99,
      "3XLarge": 44.99,
      "4XLarge": 45.99,
    },
  },
  {
    code: "CGM670",
    name: "Callaway Long Sleeve Polo",
    fullname: "Callaway Long Sleeve Core Performance Polo",
    colors: ["Black","Peacoat","Smoked Pearl"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 46.99,
      Medium: 46.99,
      Large: 46.99,
      XLarge: 46.99,
      "2XLarge": 47.99,
      "3XLarge": 48.99,
      "4XLarge": 49.99,
    },
  },
  {
    code: "CGW708",
    name: "Callaway Polo",
    fullname: "Callaway 3/4 Sleeve Polo",
    colors: ["Peacoat"],
    type: "womens",
    default_color: "Peacoat",
    sizes: {
      Small: 46.99,
      Medium: 46.99,
      Large: 46.99,
      XLarge: 46.99,
      "2XLarge": 47.99,
      "3XLarge": 48.99,
    },
  },
  {
    code: "LOG101",
    name: "OGIO® - Jewel Polo",
    fullname: "OGIO® - Jewel Polo",
    colors: ["Blacktop"],
    type: "womens",
    default_color: "Blacktop",
    sizes: {
      Small: 34.99,
      Medium: 34.99,
      Large: 34.99,
      XLarge: 34.99,
      "2XLarge": 35.99,
      "3XLarge": 36.99,
      "4XLarge": 37.99,
    },
  },
  {
    code: "PC61P",
    name: "Port & Company® Pocket Tee",
    fullname: "Port & Company® Essential Pocket Tee",
    colors: ["Jet Black"],
    type: "mens",
    default_color: "Jet Black",
    sizes: {
      Small: 15.99,
      Medium: 15.99,
      Large: 15.99,
      XLarge: 15.99,
      "2XLarge": 17.99,
      "3XLarge": 18.99,
      "4XLarge": 19.99,      
    },
  },
  {
    code: "18500",
    name: "Gildan® Hooded Sweatshirt",
    fullname: "Gildan® Heavy Blend™ Hooded Sweatshirt",
    colors: ["Black","Navy"],
    type: "mens",
    default_color: "Black",
    sizes: {
      Small: 24.99,
      Medium: 24.99,
      Large: 24.99,
      XLarge: 24.99,
      "2XLarge": 25.99,
      "3XLarge": 26.99,
      "4XLarge": 27.99,
      "5XLarge": 28.99,
    },
  },
  {
    code: "OG755",
    name: "OGIO® Commuter Jacket",
    fullname: "OGIO® Commuter Full-Zip Soft Shell",
    colors: ["Blacktop"],
    type: "mens",
    default_color: "Blacktop",
    sizes: {
      Small: 84.88,
      Medium: 84.88,
      Large: 84.88,
      XLarge: 84.88,
      "2XLarge": 86.88,
      "3XLarge": 87.88,
      "4XLarge": 88.88,
    },
  },
  {
    code: "LOG755",
    name: "OGIO® Commuter Jacket",
    fullname: "OGIO® Women's Commuter Full-Zip Soft Shell",
    colors: ["Blacktop"],
    type: "womens",
    default_color: "Blacktop",
    sizes: {
      Small: 84.88,
      Medium: 84.88,
      Large: 84.88,
      XLarge: 84.88,
      "2XLarge": 86.88,
      "3XLarge": 87.88,
      "4XLarge": 88.88,
    },
  },  
  {
    code: "HOFAPA-438-491792A",
    name: "Panther Pen",
    fullname: "White Panther Pen w/reflex blue imprint (#438)",
    colors: ["White"],
    type: "accessory",
    default_color: "White",
    sizes: {
      5000: .45,
    },
  },
  {
    code: "HOFAPA-FOB-507902L",
    name: "Silverline 'U' Keychain",
    fullname: "Silverline 'U' Keychain w/laser engraved imprint (#CG-3033)",
    colors: ["Silver"],
    type: "accessory",
    default_color: "Silver",
    discount: [
      { quantity: 1000, price: 3.65 },  
      { quantity: 1500, price: 3.49 },      
    ],
    sizes: {
      1000: 0.0, 
      1500: 0.0,     
    },
  },
   {
    code: "HOFAPA-LAPELPIN-484175Z",
    name: "Lapel Pin with Imprint",
    fullname: "White Lapel Pin w/full color imprint",
    colors: ["White"],
    type: "accessory",
    default_color: "White",
    discount: [
      { quantity: 2000, price: 1.69 },             
    ],
    sizes: {
      2000: 0.0,          
    },
  },
  {
    code: "HOFAPA-33P-484091A",
    name: ".15 Gauge Plastic Plate",
    fullname: "White Plastic Plate w/black imprint",
    colors: ["Black"],
    type: "customs",
    default_color: "Black",
    supportedStores: ["HOFAPA"],
    sizes: {
      5000: 0.49,      
    },
  },
  {
    code: "HOFAPA-34MLF-496173A",
    name: "Black Metal Frame",
    fullname: "Black Metal Frame w/acrylic insterts & white imprint",
    colors: ["Black Metal"],
    type: "customs",
    default_color: "Black Metal",
    supportedStores: ["HOFAPA"],
    sizes: {
      300: 6.99, 
      500: 6.49,      
    },
  },
  {
    code: "HOFAPA-33AP-496163A",
    name: "Black Acrylic Frame",
    fullname: "Black Acrylic Frame w/white imprint",
    colors: ["Black"],
    type: "customs",
    default_color: "Black",
    supportedStores: ["HOFAPA"],
    sizes: {
      300: 6.99, 
      500: 6.49,      
    },
  },
  {
    code: "HOFAPA-0201-507790Z",
    name: "Non-Expandable Cardstock Folder",
    fullname: "9-7/8 x 6 Non-Expandable White Marble Crush Cardstock w/full color imprint",
    colors: ["White"],
    type: "sales",
    default_color: "White",
    discount: [
      { quantity: 2500, price: 1.19 },     
    ],
    sizes: {
      2500: 0.0,           
    },
  },
   {
    code: "HOFAPA-0211-489788Z",
    name: "Expandable Cardstock Folder",
    fullname: "9-7/8 x 6 White Expandable Marble Crush Cardstock w/full color imprint",
    colors: ["White"],
    type: "sales",
    default_color: "White",
    discount: [
      { quantity: 2500, price: 1.19 },
      { quantity: 5000, price: 1.09 },      
    ],
    sizes: {
      2500: 0.0,
      5000: 0.0,           
    },
  },
]